export const getPersonalDataQueryString = () =>
	`personalData {
    personalDataTitle
    iban
    ibanError
    name
    nameError
    lastName
    lastNameError
    street
    streetError
    streetNumber
    streetNumberError
    streetAndHousenumber
    streetAndHousenumberError
    memberNumber
    memberNumberLengthError
    membershipNumberInvalidError
    membershipBenefit
    membershipBenefitHeadline
    memberBenefitDescription
    zipCode
    zipCodeError
    city
    cityError
    country
    email
    emailError
    emailRepeat
    emailRepeatError
    hints: hintsCollection(locale: $lang, limit: 3) {
      items {
        id
        tip(locale: $lang)
        linkText(locale: $lang)
        message(locale: $lang) {
          json
        }
      }
    }
  }`;

export const getAgbsQueryString = (withCategory?) =>
	`agbs {
      agbs: agbsCollection(locale: $lang, limit: 10) {
         items {
           title
           content {
             json
           }
           ${withCategory ? 'category' : ''}
           trackingLabel
         }
      }
      errorText
    }`;

export const getCheckoutPriceDetailsQueryString = (withMemberPrice) =>
	`priceDetails {
      priceDetailsHeadline
      digitalVignettesHeadline
      digitalTollSectionHeadline
      totalPriceHeadline
      payNowHeadline
      payLater
      serviceFee
      serviceDiscount
      ${withMemberPrice ? 'memberPrice' : ''}
    }`;

export const getRichTextQueryString = () =>
	`json
      links {
        entries {
          block {
            sys {
              id
            }
            __typename
            ... on Picture {
              title
              data
            }
          }
        }
      }`;

export const getCreditCardDetailsQueryString = () =>
	`creditCardDetails{
     adacAddress{
      ${getRichTextQueryString()}
     }
     cardholder
     errorCardholder
     cardNumber
     errorCardNumber
     cardDuration
     errorDuration
     cardVerificationNumber
     errorCardVerificationNumber
     paymentConfirmation
     creditCardVerificationInfo {
     id
     helpDrawerTitle
     headline
     helpDrawerRichText{
       ${getRichTextQueryString()}
     }
    }
  }`;

export const getSepaMandatQueryString = () =>
	`sepaMandat{
      headlineSepa
      cardholder
      sepaConfirmation
      existingSepaDescription
      existingMandatReferenceHeadline
    }`;

export const getPlatesLabelsQueryString = () =>
	`licensePlates{
      headlineLicenseplate(locale: $lang)
      errorLicenseplate(locale: $lang)
      errorConfirmLicenseplate(locale: $lang)
      errorSpecialLicenseplate(locale: $lang)
      checkboxLabelLicenseplate(locale: $lang)
      checkboxLabelDe(locale: $lang)
      checkboxLabelAt(locale: $lang)
      checkboxLabelRest(locale: $lang)
      helpDrawers: helpDrawersCollection(locale: $lang, limit: 3) {
        items {
          id
          helpDrawerTitle(locale: $lang)
        }
      }
      hintMessages: hintMessagesCollection(locale: $lang, limit: 3) {
        items {
          id
          tip(locale: $lang)
          linkText(locale: $lang)
          message(locale: $lang) {
            json
          }
        }
      }
      repeatLicenseplate
    }`;

export const getCartQueryString = () =>
	`cart{
    cart(locale: $lang)
    configuration(locale: $lang)
    configurationNotStarted(locale: $lang)
    cartEmpty(locale: $lang)
    chooseProduct(locale: $lang)
    gotToCartLabel(locale: $lang)
    gotToCheckout(locale: $lang)
    setValidityPeriod(locale: $lang)
    route(locale: $lang)
    chooseRoute(locale: $lang)
    addLicensePlate(locale: $lang)
    subtotal(locale: $lang)
    deleteOverlayCancel(locale: $lang)
    deleteOverlaySubmit(locale: $lang)
    deleteOverlayText(locale: $lang)
    deleteOverlayLabel(locale: $lang)
    deleteButtonLabel(locale: $lang)
    cancelConfigurtionTitle(locale: $lang)
    cancelCancelConfiguration(locale: $lang)
    changesNotSaved(locale: $lang)
    allTollRoutesUsable(locale: $lang)
    untilFurtherNotice(locale: $lang)
    additionalFlexFees(locale: $lang)
    validity(locale: $lang)
    hints: hintsCollection(locale: $lang, limit: 5) {
      items {
        id
        tip(locale: $lang)
        message(locale: $lang) {
          json
        }
      }
    }
    ${getPlatesLabelsQueryString()}
   }`;

export const getShortTextLabelsQueryString = (fields: string[]) =>
	`shortTextLabels: shortTextLabelsCollection(where: {
		fieldId_in: ${JSON.stringify(fields)}
	}) {
		items {
			fieldId
			label(locale: $lang)
		}
	}`;
